import { PkAvatar, PkIdentifier } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo } from 'react';

import type { LiveblogReporter, LiveblogStarReporter } from '../utils';

import StarReporter from './StarReporter';

import { useWindowSize } from '@hooks/useWindowSize';
import TeamFlag from '@shared/MatchUnit/utils/TeamFlag';
import { useTranslateFn } from '@shared/Translate';
import type { Team } from '@shared-types/match.types';

import * as classes from './styles.module.scss';

export const Reporter = ({
  reporter,
  team,
}: {
  reporter: LiveblogReporter | LiveblogStarReporter;
  team: 'neutral' | Team;
}) => {
  const t = useTranslateFn();
  const { isDesktop } = useWindowSize();

  if (reporter?.type === 'star') return <StarReporter reporter={reporter as LiveblogStarReporter} />;

  return (
    <PkIdentifier
      className={clsx({
        [classes.lbReporter]: true,
        'pk-py--0': true,
      })}
    >
      <PkAvatar
        slot='prefix'
        className={classes.picture}
        type='image'
        title={reporter.displayName}
        src={reporter.imageUrl}
        fallbackImage='generic-head'
        size={isDesktop ? 40 : 32}
      >
        {team !== 'neutral' && <TeamFlag slot='badge' className={classes.flag} team={team} size={16} />}
      </PkAvatar>
      <span slot='primary' className={classes.name}>
        {reporter.displayName}
      </span>
      <span slot='secondary' className={classes.role}>
        {reporter.role ?? (team === 'neutral' ? t('lb_match_reporter') : '')}
      </span>
    </PkIdentifier>
  );
};

export default memo(Reporter);
